/**
 * One answer to "does this reader want less motion?", for everything that
 * moves: the ring tween, the camera's own tweens and inertia, and the landing
 * page's settling spin. Asked at the moment something is about to move rather
 * than once at startup, so flipping the OS setting takes effect on the next
 * gesture and not the next reload.
 */

/** `prefers-reduced-motion: reduce`, defended against environments without `matchMedia`. */
export function prefersReducedMotion(): boolean {
  try {
    return (
      typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  } catch {
    return false;
  }
}
